import { DATA_SCOPES, FILTER_TYPE } from "../filterConstants"
import { DateFilter } from "../filterTypes/dateFilter"
import { NumberFilter } from "../filterTypes/numberFilter"
import { StringFilter } from "../filterTypes/stringFilter"

export class OTAMessageID extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Message ID",
      FILTER_TYPE.OTA_MESSAGE.ID,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    _alg_release,
    otaMessage,
  ) {
    return otaMessage.message_id
  }
}

export class OTAType extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Message Type",
      FILTER_TYPE.OTA_MESSAGE.TYPE,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    _alg_release,
    otaMessage,
  ) {
    return otaMessage.message_type
  }
}

export class OTAMessage extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Message",
      FILTER_TYPE.OTA_MESSAGE.MESSAGE,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    _alg_release,
    otaMessage,
  ) {
    return JSON.stringify(otaMessage.message)
  }
}

export class OTAProvider extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Message Provider",
      FILTER_TYPE.OTA_MESSAGE.PROVIDER,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    _alg_release,
    otaMessage,
  ) {
    return otaMessage.provider
  }
}

export class OTAStatus extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Status",
      FILTER_TYPE.OTA_MESSAGE.STATUS,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    _alg_release,
    otaMessage,
  ) {
    return otaMessage.status
  }
}

export class OTAMessageIndex extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Message Index",
      FILTER_TYPE.OTA_MESSAGE.INDEX,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    _alg_release,
    otaMessage,
  ) {
    return otaMessage.index
  }
}

export class OTACreatedAt extends DateFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Created At",
      FILTER_TYPE.OTA_MESSAGE.CREATED_AT,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(
    _device,
    _deviceGroups,
    _insight,
    _insightMetrics,
    _update,
    _alert,
    _user,
    _alg_meta,
    _alg_release,
    otaMessage,
  ) {
    return otaMessage.created_at
  }
}
